import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Intro } from "./components/intro";
import { Welcome } from "./components/welcome";
import { Registration } from "./components/registration";
import { Program } from "./components/program";
import { Info } from "./components/info";
import { Venue } from "./components/venue";
import { Contact } from "./components/contact";
import { Keynote } from "./components/keynote";
import { Extension } from "./components/extension";
import { Proceedings } from "./components/proceedings";
import { Sponsors } from "./components/sponsors";
import { Award } from "./components/award";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Navigation />
      <Intro data={landingPageData.Intro} />
      <Extension data={landingPageData.Extension} />
      <Welcome data={landingPageData.Welcome} />
      <Venue data={landingPageData.Venue} />
      <Program data={landingPageData.Program} />
      <Info data={landingPageData.Info} />
      <Keynote data={landingPageData.Keynote} />
      <Registration data={landingPageData.Registration} />
      <Proceedings data={landingPageData.Proceedings} />
      <Sponsors data={landingPageData.Sponsors} />
      <Award data={landingPageData.Award} />
      <Contact data={landingPageData.Contact} />
    </div>
  );
};

export default App;
